import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var SeparatorVertical = createReactComponent("SeparatorVertical", ["svg", defaultAttributes, [["line", {
  x1: "12",
  y1: "3",
  x2: "12",
  y2: "21",
  key: "1cuoio"
}], ["polyline", {
  points: "8 8 4 12 8 16",
  key: "n464wr"
}], ["polyline", {
  points: "16 16 20 12 16 8",
  key: "11d4sb"
}]]]);
export default SeparatorVertical;